import request, { download } from '../network';
import { tansParams } from '@/utils/utils';

export const searchOrderListApi = (shopId: any, params: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/order/${shopId}/search`,
    method: 'GET',
    params,
  });
};

export const getOrderDetailApi = (shopId: any, id: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/order/${shopId}/detail/${id}`,
    method: 'GET',
  });
};

export const updateOrderStatusApi = (shopId: any, params: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/order/${shopId}/update-status`,
    method: 'POST',
    params,
  });
};

export const shipOrderApi = (shopId: any, data: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/order/${shopId}/ship`,
    method: 'POST',
    data,
  });
};

export const getOrderStatusListApi = () => {
  return request({
    url: '/lz-member-server/royalcanin/admin/points/exchange/order/status/list',
    method: 'GET',
  });
};

export const getShippingStatusListApi = () => {
  return request({
    url: '/member/royalcanin/admin/points/exchange/order/shipping-status/list',
    method: 'GET',
  });
};

export const getInstanceTypeListApi = () => {
  return request({
    url: '/lz-member-server/royalcanin/admin/points/exchange/order/instance-type/list',
    method: 'GET',
  });
};

export const getUserOrderListApi = (shopId: any, userId: any, params: any) => {
  return request({
    url: `/lz-member-server/royalcanin/admin/points/exchange/order/${shopId}/user/${userId}/list`,
    method: 'GET',
    params,
  });
};

export const exportPhysicalOrderApi = (shopId: any, params: any) => {
  const query = tansParams(params);
  const url = `/member/royalcanin/admin/points/exchange/order/${shopId}/export${query ? `?${query.slice(0, -1)}` : ''}`;
  return download(url);
};

export const downloadOrderImportTemplateApi = (shopId: any) => {
  const url = `/member/royalcanin/admin/points/exchange/order/${shopId}/import-template`;
  return download(url);
};

export const importPhysicalOrderApi = (shopId: any, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: `/member/royalcanin/admin/points/exchange/order/${shopId}/import`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const sendPendingCouponV2Api = (data: any) => {
  return request({
    url: '/member/royalcanin/applet/acxCoupon/sendPendingCouponv2',
    method: 'POST',
    data,
  });
};
